import { Action } from "@ngrx/store";
import {
  ChartFilters,
  ChartMeta,
  SuggestedChartDetails,
} from "../models/charts-page.model";
import Highcharts from "highcharts";

export const SET_CHART_META = "SET_CHART_META";
export const SET_SUGGESTED_CHART_DETAILS = "SET_SUGGESTED_CHART_DETAILS";
export const SET_CHART_INSTANCE = "SET_CHART_INSTANCE";
export const SET_CHART_FILTERS = "SET_CHART_FILTERS";
export const CLEAR_CHART_FILTERS = "CLEAR_CHART_FILTERS";
export class SetChartMeta implements Action {
  readonly type = SET_CHART_META;
  constructor(public payload: ChartMeta) {}
}

export class SetSuggestedChartDetails implements Action {
  readonly type = SET_SUGGESTED_CHART_DETAILS;
  constructor(public payload: SuggestedChartDetails) {}
}

export class SetChartInstance implements Action {
  readonly type = SET_CHART_INSTANCE;
  constructor(public payload: Highcharts.Chart) {}
}

export class SetChartFilters implements Action {
  readonly type = SET_CHART_FILTERS;
  constructor(public payload: ChartFilters) {}
}

export class ClearChartMeta implements Action {
  readonly type = CLEAR_CHART_FILTERS;
}

export type Actions =
  | SetChartMeta
  | SetSuggestedChartDetails
  | SetChartInstance
  | SetChartFilters
  | ClearChartMeta;
// | ChangeChartType
// | SetSuggestedLines
// | ChangeTickers
// | ChangeLineItem
// | ChangeIdentifier
// | SetNewFilter
// | SetChartFilters;
